import { forwardRef, useState } from 'react';
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";

import { Flex, IconButton, Input, type InputProps } from '@chakra-ui/react';

const PasswordInput = forwardRef<HTMLInputElement, InputProps>(({ ...props }, ref) => {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <Flex width="full">
      <Input {...props} type={showPassword ? "text" : "password"} pr="44px" ref={ref} />
      <IconButton
        onClick={() => setShowPassword(!showPassword)}
        variant="ghost"
        position="absolute"
        zIndex={1}
        right={0}
      >
        {showPassword ? (
          <FaRegEyeSlash />
        ) : (
          <FaRegEye />
        )}
      </IconButton>
    </Flex>
);
});

export default PasswordInput;